import React, { useEffect } from "react";
import store from "store2";

const LocationChecks = (props: { values: any; setFieldValue: any , jobId:any;}) => {
  const { values, setFieldValue,jobId } = props;

  const switches = [
    { label: "Has a smoodi router?", name: "hasSmoodiRouter" },
    { label: "Has Wifi extender?", name: "hasWifiExtender" },
    { label: "Has pressure pump?", name: "hasPressurePump" },
    { label: "Has pressure tank?", name: "hasPressureTank" },
  ];

  // Restore stored values on mount
  useEffect(() => {
    const jobData = store.get("job_id_data") || {};
    const locationData = jobData[jobId]?.location || {};
    switches.forEach(({ name }) => {
      if (locationData !== undefined) {
        setFieldValue(name, locationData[name]);
      }
    });
  }, []);
  
  // Handle toggle and store value
  const handleToggle = (name: string, checked: boolean) => {
    setFieldValue(name, checked);
    const jobData = store.get("job_id_data") || {};
    jobData[jobId] = {
      ...jobData[jobId],
      location: {
        ...jobData[jobId]?.location,
        [name]: checked, // Use the name as the key dynamically
      },
    };
    store.set("job_id_data", jobData);
  };

  return (
    <div className="mt-4">
      {switches.map((item, idx) => (
        <div
          key={idx}
          className="d-flex justify-content-between align-items-center mb-3"
        >
          <label className="wo-label">{item.label}</label>
          <div className="form-check form-switch form-check-custom">
            <input
              className="form-check-input"
              type="checkbox"
              checked={values[item.name]}
              onChange={(e) => handleToggle(item.name, e.target.checked)}
              name={item.name}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LocationChecks;
